import * as Models  from "../Models/Surveys/SurveyDataModel";


export class SurveyStatusManager {
    /*
     *  Returns true if the survey is in a state that requires the supplier to take action.
     */
    public static getWorkedOnBySuppliersState(surveyState: number): boolean {
        return [Models.SurveyStatusState.Sent, Models.SurveyStatusState.InProgress, Models.SurveyStatusState.RevisionSent, Models.SurveyStatusState.RevisonInProgress,
        Models.SurveyStatusState.RequestInitiated, Models.SurveyStatusState.RevisionRequestInitiated].includes(surveyState);
    }
    /*
     *  Returns true if survey is neither sent nor a draft.
     */
    public static surveyIsNotSentOrDraft(surveyState: number): boolean {
        return ![Models.SurveyStatusState.Sent, Models.SurveyStatusState.Draft, Models.SurveyStatusState.RequestInitiated].includes(surveyState);
    }
    /*
     *  Returns true if survey is not in a resolved state.
     */
    public static surveyIsNotResolved(surveyState: number): boolean {
        return ![Models.SurveyStatusState.ResponseReceived, Models.SurveyStatusState.RevisionResponseReceived, Models.SurveyStatusState.AllAccepted].includes(surveyState);
    }
}